const scrollToFixed = () => {

    require('scrolltofixed');

    var stf = $('.scrolltofixed');

    if ($(window).width() < 1190) {

        stf.trigger('detach.ScrollToFixed');

    } else {

        stf.scrollToFixed({
            marginTop: 30,
            limit: function () {

                var offset = $('.scroll-to-fixed-end').offset().top - stf.outerHeight() - 30,

                    limit = Math.round(offset);

                return limit;

            },
            unfixed: function(){
                $(this).css({
                    'left': '15px',
                    'top':'inherit'
                });
            }
        });

    }

}

module.exports = {

    scrollToFixed,

};